module.exports = __webpack_public_path__ + "img/codigo api correios 5.a313908d.png";